module.exports = __webpack_public_path__ + "static/media/Autogrow EnviroSensor IntelliClimate CO2 Sensor.7571e71d.webp";